import { useEffect } from 'react';
import { AdvertisingBannerDto } from '@/app/store/api/restApi';
import { removeViewedBanner, useAppDispatch, useAppSelector } from '@/app/store';

export const useActualiseBanners = ({
  banners,
  bannersLoading,
}: {
  banners: AdvertisingBannerDto[];
  bannersLoading: boolean;
}) => {
  const dispatch = useAppDispatch();
  const viewedBanners = useAppSelector((state) => state.initial.viewedBanners);

  useEffect(() => {
    if (bannersLoading) return;

    viewedBanners.forEach((bannerId) => {
      const banner = banners.find((b) => b.id === bannerId);
      if (!banner) dispatch(removeViewedBanner(bannerId));
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [banners, bannersLoading, dispatch]);
};
